<template>
  <router-link
    :to="url"
    :class="{ 'text-gray': order.deleted == 1 && styled }"
    :title="order.deleted ? '已删除' : order.number"
  >
    <slot v-if="$slots.content" name="content"></slot>
    <component v-else :is="element">{{ order.number }}</component>
  </router-link>
</template>
<script>
export default {
  props: {
    order: {
      type: Object,
      default: function () {
        return {
          id: 0,
          number: '',
          deleted: 0,
        }
      },
    },
    origin: {
      type: Number,
      default: 0,
    },
    styled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    url() {
      let type = ''
      if (this.order.status == 100) {
        type = '/done'
      }

      if (this.order.deleted == 1) {
        type = '/deleted'
      }
      return (
        `/dashboard/${this.order.customer_user_id ? 'customer' : 'dealer'}` +
        type +
        '/orders/' +
        +this.order.id +
        '?origin=' +
        this.origin
      )
    },
    element() {
      if (this.order.deleted == 1 && this.styled) {
        return 'del'
      }
      return 'span'
    },
  },
}
</script>